import ParcelexApi from '@/services/parcelex';
import isMobile from '@/lib/isMobile';

const platforms = ({
  vtex: 'vtex',
  zoom: 'custom',
});

function getDevice(device) {
  return (device || (isMobile() ? 'mobile' : 'desktop')) === 'desktop'
    ? 'desktop' : 'mobile';
}

export default {
  logPdpEvents({ type, data }) {
    const {
      apiKey,
      result,
      sessionId,
      user,
      productInfo,
      preApprove,
      trackId,
      device,
      context,
    } = data;

    return ParcelexApi.post('/public/event', {
      apiKey,
      page: 'modal',
      type,
      url: window.location.href,

      device: getDevice(device),

      platform: platforms[context] || null,

      phone: (user && user.phone) || null,
      cpf: (user && user.cpf) || null,
      email: (user && user.email) || null,
      zipCode: (user && user.zipCode) || null,

      products: [{
        name: (productInfo && productInfo.name) || null,
        description: (productInfo && productInfo.description) || null,
        sku: (productInfo && productInfo.id) || null,
        value: (productInfo && productInfo.value) || null,
        image: (productInfo && productInfo.imageUrl) || null,
        url: (productInfo && productInfo.url) || null,
        category: (productInfo && productInfo.category) || null,
        categoryId: (productInfo && productInfo.categoryId) || null,
        amount: (productInfo && productInfo.amount) || null,
        seller: (productInfo && productInfo.seller) || null,
      }],

      sessionId: sessionId || null,

      result: result || null,
      preApprove: preApprove || null,
      trackId,
    });
  },
  logCheckoutEvents({ type, data }) {
    const {
      page,
      apiKey,
      device,
      sessionId,
      user,
      trackId,
      context,
      order,
      checkoutId,
      optionId,
    } = data;
    const { shipping } = order;
    const products = order.products || [];

    return ParcelexApi.post('/public/event', {
      apiKey,
      page: page || 'checkout',
      type,
      url: window.location.href,

      device: getDevice(device),

      platform: platforms[context] || null,

      phone: (user && user.phone) || null,
      cpf: (user && user.cpf) || null,
      email: (user && user.email) || null,
      name: (user && user.name) || null,
      zipCode: (shipping && shipping.zipCode) || null,
      addressNumber: (shipping && shipping.number) || null,
      addressStreet: (shipping && shipping.street) || null,
      addressComplement: (shipping && shipping.complement) || null,
      city: (shipping && shipping.city) || null,
      state: (shipping && shipping.state) || null,

      products: products.map((product) => ({
        name: product.name || null,
        description: product.description || null,
        sku: product.id || null,
        value: product.value || null,
        image: product.image || null,
        url: product.url || null,
        category: product.category || null,
        categoryId: product.categoryId || null,
        seller: product.seller || null,
        amount: product.amount || null,
      })),

      sessionId: sessionId || null,
      trackId,
      checkoutId: checkoutId || null,
      optionId: optionId || null,
    });
  },
  logOnboardingEvents({ type, data }) {
    const {
      apiKey,
      page,
      device,
      user,
      trackId,
      checkoutId,
      productInfo,
      retailerId,
    } = data;

    return ParcelexApi.post('/public/event', {
      apiKey,
      page: page || 'onboarding',
      type,
      url: window.location.href,
      retailerId,

      device: getDevice(device),

      phone: (user && user.phone) || null,
      cpf: (user && user.cpf) || null,
      email: (user && user.email) || null,
      name: (user && user.name) || null,
      zipCode: (user && user.zipCode) || null,
      addressNumber: (user && user.addressNumber) || null,
      addressStreet: (user && user.addressStreet) || null,
      addressComplement: (user && user.addressComplement) || null,
      city: (user && user.city) || null,
      state: (user && user.state) || null,

      products: [{
        name: (productInfo && productInfo.name) || null,
        description: (productInfo && productInfo.description) || null,
        sku: (productInfo && productInfo.id) || null,
        value: (productInfo && productInfo.value) || null,
        image: (productInfo && productInfo.imageUrl) || null,
        url: (productInfo && productInfo.url) || null,
        category: (productInfo && productInfo.category) || null,
        categoryId: (productInfo && productInfo.categoryId) || null,
        amount: (productInfo && productInfo.amount) || null,
        seller: (productInfo && productInfo.seller) || null,
      }],

      checkoutId: checkoutId || null,
      trackId,
    });
  },
  log(params) {
    const apiData = {
      apiKey: params.apiKey,
      env: params.env,
      device: params.device,
      // event
      page: params.page || 'checkout',
      type: params.type,
      // user
      sessionId: params.sessionId,
      phone: params.user.phone,
      cpf: params.user.cpf,
      email: params.user.email,
      // shipping
      addressStreet: params.order.shipping.addressStreet,
      addressNumber: params.order.shipping.addressNumber,
      addressComplement: params.order.shipping.addressComplement,
      city: params.order.shipping.city,
      state: params.order.shipping.state,
      // options
      preApproved: params.preApproved,
    };

    // product
    const product = params.order.products[0];
    apiData.productAmount = product.amount;
    apiData.productPrice = product.value;
    apiData.productName = product.name;
    apiData.productImage = product.image;
    apiData.productUrl = product.url;
    apiData.categoryName = product.category;
    apiData.categoryId = product.categoryId;

    return ParcelexApi.post('/public/event', apiData);
  },
  logLoginEvents({ type, data }) {
    const { apiKey, user, trackId } = data;

    return ParcelexApi.post('/public/event', {
      apiKey,
      page: 'login',
      type,
      phone: (user && user.phone) || null,
      cpf: (user && user.cpf) || null,
      email: (user && user.email) || null,
      zipCode: (user && user.zipCode) || null,

      trackId,

      platform: 'parcelex',
      url: window.location.href,

      device: isMobile() ? 'mobile' : 'desktop',
    });
  },
  logSiteEvents({ type, data }) {
    const { apiKey, user, trackId } = data;

    return ParcelexApi.post('/public/event', {
      apiKey,
      page: 'site',
      type,
      phone: (user && user.phone) || null,
      cpf: (user && user.cpf) || null,
      email: (user && user.email) || null,
      zipCode: (user && user.zipCode) || null,

      trackId,

      platform: 'parcelex',
      url: window.location.href,

      device: isMobile() ? 'mobile' : 'desktop',
    });
  },
  logDeniedEvents({ action, origin, data }) {
    return ParcelexApi.post('public/event/send', {
      action,
      source: 'denied-credit-page',
      origin,
      data: {
        ...data,
      },
    }).catch((e) => console.error(e));
  },
};
